// extracted by mini-css-extract-plugin
module.exports = {"meta_card":"MetaCard_meta_card__1nPds"};